import { UserTrainingStats } from '../../models/TrainingLaunch';
import { TrainingRepository } from '../../repositories/TrainingRepository';

export class GetUserTrainingStatsUseCase {
  constructor(private trainingRepository: TrainingRepository) {}

  async execute(userId: string): Promise<UserTrainingStats | null> {
    return this.trainingRepository.getUserTrainingStats(userId);
  }
}
